<h2 mat-dialog-title>Project wijzigen</h2>

<mat-dialog-content>
    <div class="text-muted mb-2">
        {{data.registration.starttime | date:'EEEE d MMM yyyy'}} ·
        {{data.registration.starttime | date:'HH:mm' : 'UTC'}} - {{data.registration.endtime | date:'HH:mm' : 'UTC'}}
    </div>

    <div>
        <ng-select
            [formControl]="selectedWorkProjectId"
            appendTo=".cdk-overlay-pane"
            [clearable]="false"
            [items]="projectOptions"
            [searchable]="true"
            bindLabel="label"
            bindValue="id"
            virtualScroll="true"
            placeholder="Zoek een project">
        </ng-select>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">Annuleren</button>
    <button
        (click)="save()"
        [disabled]="selectedWorkProjectId.value === data.registration.work_project_id"
        mat-flat-button
        type="button">
        Opslaan
    </button>
</mat-dialog-actions>
